import mainImage from './sticky_cubes.jpg';
import image1 from './sticky_cubes1.jpg';
import image2 from './sticky_cubes2.jpg';


const details = [
    { 
      id: 2,
      name: 'Sticki Kubes',
      slideTitle: 'Sticki Kubes',
      slideImage: mainImage,
      images: [mainImage, image1, image2],
      description: 'Great way to entertain both my kids (ages 3 and 7) while out to eat or in a waiting room. They\'ve used the cubes to build on tables, chairs, walls and windows. They can sort by color, create letters, build structures — a multitude of options depending upon where their imagination takes them! Portable, easy to clean, and a great price point.',
      link:'https://amzn.to/40i4Bn1',
    }
]

export default details[0];